/**
 * Foundation Formatting · Sort — ordinamento alfabetico italiano centralizzato.
 *
 * STANDARD UFFICIALE Gruppo Impresa Suite:
 *   Ordinamento di liste per nome (o altra chiave stringa) usando
 *   `Intl.Collator("it")`. Case-insensitive, numeri "naturali", punteggiatura
 *   ignorata. Stabile: a parità di chiave preserva l'ordine di input.
 *
 * Le liste ordinabili sono qualunque `Array<{[nameKey]: string, [idKey]?: string}>`
 * (aziende, clienti, prodotti, utenti, categorie, ecc.). Nessuna semantica
 * di dominio Presenze — utilizzabile da tutti i Product Pack Suite.
 */

/**
 * Collator italiano condiviso, allocato una sola volta.
 * NB: mantenere `numeric: true` è la convenzione Suite (es. "Studio 2" precede
 * "Studio 10"); modificare questa opzione richiede rivedere i test.
 */
export const italianCollator = new Intl.Collator("it", {
  sensitivity: "base",
  numeric: true,
  ignorePunctuation: true,
});

/**
 * Ordina una lista per nome con collazione italiana canonica.
 *
 * @param {Array} list       Elenco da ordinare.
 * @param {object} [options] Opzioni:
 *   - `nameKey`      chiave stringa da usare per il confronto (default `"name"`).
 *   - `firstIdKey`   chiave da leggere per il "pin in top" (usa con `firstIdValue`).
 *   - `firstIdValue` valore che se trovato per `firstIdKey` porta l'elemento in
 *                    prima posizione (utile per opzioni "aggregate" o "tutti").
 * @returns {Array} Nuova lista ordinata (non muta l'input). Se `list` non è un
 *   array valido, restituisce `[]`.
 */
export function sortByNameIt(list, options = {}) {
  if (!Array.isArray(list)) return [];
  const nameKey = options.nameKey || "name";
  const firstIdKey = options.firstIdKey;
  const firstIdValue = options.firstIdValue;
  const hasPin = typeof firstIdKey === "string" && firstIdValue !== undefined && firstIdValue !== null;
  return [...list].sort((a, b) => {
    if (hasPin) {
      const aPin = a?.[firstIdKey] === firstIdValue;
      const bPin = b?.[firstIdKey] === firstIdValue;
      if (aPin && !bPin) return -1;
      if (bPin && !aPin) return 1;
      if (aPin && bPin) return 0;
    }
    const an = (a?.[nameKey] ?? "").toString();
    const bn = (b?.[nameKey] ?? "").toString();
    return italianCollator.compare(an, bn);
  });
}
